import { createDrawerNavigator } from "@react-navigation/drawer";
import { StyleSheet, ScrollView } from "react-native";
import Home from "./Home";
import Experience from "./Experience";
import Portfolio from "./Portfolio";
import Education from "./Education";
import Contact from "./Contact";
import About from "./About";
const Drawer = createDrawerNavigator();
export default function MyDrawer({ MyDrawer }) {
  return (
    <Drawer.Navigator
      initialRouteName="Home"
      drawerPosition="right"
      style={styles.container}
    >
      <Drawer.Screen
        name="Home"
        component={Home}
        options={{
          headerTitle: "Home",
          headerTitleStyle: { color: "white" },
          headerStyle: { backgroundColor: "#000304",shadowColor: 'transparent',  
          elevation: 0 },
          headerTintColor: "#FFFFFF",
          defaultNavigationOptions: {
            title: "Aligned Center",
            headerTitleAlign: "center",
            
          },
        }}
      />
      <Drawer.Screen
        name="Experience"
        component={Experience}
        options={{ headerTitle: "Experience", 
        headerTitleStyle: { color: "white" },
        headerStyle: { backgroundColor: "#000304",shadowColor: 'transparent',  
        elevation: 0 },
        headerTintColor: "#FFFFFF",
        defaultNavigationOptions: {
          title: "Aligned Center",
          headerTitleAlign: "center",
          
        },
      }}
      />
      <Drawer.Screen
        name="Portfolio"
        component={Portfolio}
        options={{ headerTitle: "Portfolio",
        headerTitle: "Portfolio", 
        headerTitleStyle: { color: "white" },
        headerStyle: { backgroundColor: "#000304",shadowColor: 'transparent',  
        elevation: 0 },
        headerTintColor: "#FFFFFF",
        defaultNavigationOptions: {
          title: "Aligned Center",
          headerTitleAlign: "center",
          
        },
      }}
      />
      <Drawer.Screen
        name="Education"
        component={Education}
        options={{ headerTitle: "Education",
        headerTitle: "Education", 
        headerTitleStyle: { color: "white" },
        headerStyle: { backgroundColor: "#000304",shadowColor: 'transparent',  
        elevation: 0 },
        headerTintColor: "#FFFFFF",
        defaultNavigationOptions: {
          title: "Aligned Center",
          headerTitleAlign: "center",
          
        },
       }}
      />
      <Drawer.Screen
        name="Contact"
        component={Contact}
        options={{ headerTitle: "Contact",
        headerTitle: "Contact", 
        headerTitleStyle: { color: "white" },
        headerStyle: { backgroundColor: "#000304",shadowColor: 'transparent',  
        elevation: 0 },
        headerTintColor: "#FFFFFF",
        defaultNavigationOptions: {
          title: "Aligned Center",
          headerTitleAlign: "center",
          
        },
      }}
      />
      <Drawer.Screen
        name="About"
        component={About}
        options={{ headerTitle: "About",
        headerTitle: "About", 
        headerTitleStyle: { color: "white" },
        headerStyle: { backgroundColor: "#000304",shadowColor: 'transparent',  
        elevation: 0 },
        headerTintColor: "#FFFFFF",
        defaultNavigationOptions: {
          title: "Aligned Center",
          headerTitleAlign: "center",
          
        },
       }}
      />
    </Drawer.Navigator>
  );
}
const styles = StyleSheet.create({
  container: {
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: "red",
  },
});
